import React, { Component } from 'react';
import Head from 'next/head'
import { parse, differenceInSeconds } from 'date-fns';
import { fetchFixture, fetchEvents, fetchParticipants } from '../api/fixtures'
import { Header, FixtureHeader, Footer, GalleryThumbnail, PageWrapper } from '../components'
import Timeline from '../components/Timeline'
import GooglePhoto from 'react-google-photo';
const INITIAL_STATE = {
    timeline: [],
    scores: {},
    state: {
        isInProgress: false,
        isStarted: false,
        isPaused: false,
        isFinished: false,
        startedAt: null,
        pausedAt: null,
        pausedFor: 0,
        eventTimes: {},
        period: 1
    }
};

class ReportPage extends Component {
  static async getInitialProps({req, query, props}) {
    const fixturePromise = fetchFixture(query.fixture)
    const eventsPromise = fetchEvents(query.fixture)
    const participantsPromise = fetchParticipants(query.fixture)

    let fixture = await fixturePromise
    let events = await eventsPromise
    let participants = await participantsPromise
    let state = events.data.reduce((v, w) => processEventForState(v, w), INITIAL_STATE)
    let indexedEvents = events.data.reduce((v, w) => processEventForEvents(v, w), {})
    let indexedParticipants = participants.data.reduce((v, w) => processParticipant(v, w), {})

    return { fixture, events: indexedEvents, state, participants: indexedParticipants, organisationId: props.organisationId }
  }

  state = {
    index: 0,
    open: false
  };

  handleClickPrev = () => {
    this.setState({ index: this.state.index - 1 });
  };

  handleClickNext = () => {
    this.setState({ index: this.state.index + 1 });
  };

  handleOpen = (index) => {
    this.setState({ index: index });
    this.setState({ open: true });
  }

  handleClose = () => {
    this.setState({ open: false });
  };


  render() {
    const { fixture, events, state, participants, organisationId, organisation, pages } = this.props
    const images = fixture.gallery && fixture.gallery.images.data.map(function(i) {
      return { src: i.file.uri, width: 1024, height: 682}
    });
    const { open, index } = this.state;
    return (
      <div className={`u-grid u-grid--basic u-grid-${organisationId}`}>
        <Head>
          <title>{`${organisation.name} | Fixture Report `}</title>
          <meta property="og:title" content={`BRHA | Fixture Report `} />

        </Head>
        <Header region={organisation.name} regionId={organisation.id} pages={pages}/>
        <div className="u-grid__main">

          <div className="c-timeline">
            <FixtureHeader fixture={fixture} state={state} />
            <Timeline fixture={fixture} events={events} state={state} participants={participants} />
          </div>
          {fixture.gallery &&
            <div>
              <h1>{fixture.gallery.title}</h1>
              <div className="c-gallery">
                {fixture.gallery.images.data.map( (i,index) =>
                  <GalleryThumbnail key={i.id} image={i} handleClick={() => this.handleOpen(index)} />
                )}
              </div>
              <GooglePhoto
                open={open}
                src={images}
                srcIndex={index}
                onClickPrev={this.handleClickPrev}
                onClickNext={this.handleClickNext}
                onClose={this.handleClose}
              />
            </div>
          }
        </div>
        <Footer regionId={organisation.id}/>
      </div>
    )
  }

}

export default PageWrapper(ReportPage)


function processParticipant(state, participant) {
  return {
    ...state,
    [participant.id]: participant,
  }
}

function processEventForEvents(state, event) {
    const newState = { ...state };

    newState[event.id] = {
        children: [],
        ...state[event.id],
        ...event
    };

    if (event.parent_id && state[event.parent_id] && !state[event.id]) {
        newState[event.parent_id] = {
            ...state[event.parent_id],
            children: [
                ...state[event.parent_id].children,
                event
            ]
        };
    }

    return newState;
}

function processEventForState(state, event) {

    if (event.type == 'game_endperiod') {
      event.period = state.state.period;
      state.state.period++;
    }
    if (state.timeline.indexOf(event.id) !== -1) {
        return state;
    } else {
        return {
            ...state,
            timeline: [ event.id, ...state.timeline ],
            scores: updateScores(state.scores, event),
            state: updateState(state.state, event)
        };
    }
}

function updateScores(state = {}, { type, entry_id }) {
    switch (type) {
        case 'goal':
        case 'own_goal':
            return {
                ...state,
                [entry_id]: (state[entry_id] || 0) + 1
            };

        default:
            return state;
    }
}

function updateScoresOnEventRemoval(state = {}, { type, entry_id }) {
    switch (type) {
        case 'goal':
        case 'own_goal':
            return {
                ...state,
                [entry_id]: (state[entry_id] || 0) - 1
            };

        default:
            return state;
    }
}

function updateState(state, { type, happened_at }) {
    const happenedAt = parse(happened_at);
    const newState = processEventType(state, type, happenedAt);
    const eventTime = calculateEventTime(newState, happenedAt);

    newState.eventTimes = {
        ...newState.eventTimes,
        [happened_at]: eventTime
    };

    return newState;
}

function calculateEventTime({ startedAt, pausedFor }, happenedAt) {
    return differenceInSeconds(happenedAt, startedAt) - pausedFor;
}

function processEventType(state, type, happenedAt) {
    switch (type) {
        case 'game_start':
            return {
                ...state,
                isStarted: true,
                isInProgress: true,
                startedAt: happenedAt
            };

        case 'game_finish':
            return {
                ...state,
                isFinished: true,
                isInProgress: false
            };

        case 'game_pause':
            return {
                ...state,
                isPaused: true,
                pausedAt: happenedAt
            };
        case 'game_endperiod':
            return {
                ...state,
                isPaused: true,
                pausedAt: happenedAt,
                period: state.period++
            };
        case 'game_resume':
            const pausedFor = differenceInSeconds(happenedAt, state.pausedAt);
            return {
                ...state,
                isPaused: false,
                pausedAt: null,
                pausedFor: state.pausedFor + pausedFor
            };

        default:
            return state;
    }
}
